module.exports = function (Component) { Component.options.__i18n = '{"en":{"screen-share-and-camera":"Share Screen & Camera","screen-share-only":"Share Screen (Disable Camera)","stop-screen-share":"Stop Screen Share"},"de":{"screen-share-and-camera":"Share Screen & Camera","screen-share-only":"Share Screen (Disable Camera)","stop-screen-share":"Stop Screen Share"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ScreenMenuSelect.vue
// module id = 147
// module chunks = 1